var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page5-container" },
    [
      (!_vm.isWritingMessage && !_vm.isMobile()) || _vm.isMobile()
        ? _c("div", { staticClass: "page5-content-container" }, [
            _c(
              "ul",
              { staticClass: "cards-container" },
              [
                !_vm.selectedCardsOccasions.includes("View All")
                  ? _c("p", { staticClass: "other-gifts" }, [
                      _vm._v(_vm._s(_vm.selectedCardsOccasions.join(", ")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.sortedCards, function(card) {
                  return _c("li", { key: card.id }, [
                    _c("div", { staticClass: "card-container" }, [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "main-image-container",
                            class:
                              _vm.selectedCard && _vm.selectedCard.id == card.id
                                ? "selected"
                                : ""
                          },
                          [
                            _vm.isBrandable(card)
                              ? _c("div", { staticClass: "edit-float" }, [
                                  _c("p", [_vm._v("Add your logo")]),
                                  _vm._v(" "),
                                  _vm._m(0, true)
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.selectedCard && _vm.selectedCard.id == card.id
                              ? _c("img", {
                                  staticClass: "green-check",
                                  attrs: {
                                    src:
                                      "https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "main-image lazyload",
                              attrs: {
                                width: "280",
                                height: "280",
                                loading: "lazy",
                                src: _vm._f("getProductImage")(card)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectCard(card)
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(card.title))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-price" }, [
                          _vm._v(_vm._s(_vm._f("moneyFormat")(card)))
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.hasMinimum(card) && _vm.boxQty < _vm.cardMinimum(card)
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "happybox-button white border disabled",
                              attrs: { disabled: "true" }
                            },
                            [
                              _vm._v(
                                "Minimum: " +
                                  _vm._s(_vm.cardMinimum(card)) +
                                  " boxes"
                              )
                            ]
                          )
                        : _vm.selectedCard &&
                          _vm.selectedCard.id == card.id &&
                          _vm.buttonDisabled
                        ? _c(
                            "button",
                            {
                              staticClass: "happybox-button green border",
                              on: {
                                click: function($event) {
                                  return _vm.selectCard(card)
                                }
                              }
                            },
                            [_vm._v("Write message")]
                          )
                        : _vm.selectedCard &&
                          _vm.selectedCard.id == card.id &&
                          !_vm.buttonDisabled
                        ? _c(
                            "button",
                            {
                              staticClass: "happybox-button green border",
                              on: { click: _vm.openCart }
                            },
                            [_vm._v("Next >")]
                          )
                        : _vm.isBrandable(card)
                        ? _c(
                            "button",
                            {
                              staticClass: "happybox-button white border",
                              on: {
                                click: function($event) {
                                  return _vm.selectCard(card)
                                }
                              }
                            },
                            [_vm._v("Add Design")]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "happybox-button white border",
                              on: {
                                click: function($event) {
                                  return _vm.selectCard(card)
                                }
                              }
                            },
                            [_vm._v("Select Design")]
                          )
                    ])
                  ])
                })
              ],
              2
            )
          ])
        : !_vm.isMobile()
        ? _c(
            "div",
            { staticClass: "card-message-wrapper" },
            [
              !_vm.isBrandableCard
                ? _c("NormalCard", {
                    attrs: {
                      buttonDisabled: _vm.buttonDisabled,
                      isLoading: _vm.isLoading,
                      buttonText: _vm.buttonText,
                      selectedCard: _vm.selectedCard,
                      isBlankMessage: _vm.isBlankMessage
                    },
                    on: {
                      closecard: _vm.closeCard,
                      changeblankmessage: _vm.changeBlankMessage,
                      opencart: _vm.openCart,
                      changemessage: function($event) {
                        return _vm.changeMessage($event)
                      },
                      changefrom: function($event) {
                        return _vm.changeFrom($event)
                      }
                    }
                  })
                : _c("BrandableCard", {
                    attrs: {
                      selectedAddon: _vm.selectedCard,
                      isBlankMessage: _vm.isBlankMessage
                    },
                    on: {
                      closecard: _vm.closeCard,
                      changeblankmessage: _vm.changeBlankMessage,
                      changemessage: function($event) {
                        return _vm.changeMessage($event)
                      },
                      changefrom: function($event) {
                        return _vm.changeFrom($event)
                      }
                    }
                  })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "write-message-page",
          class:
            _vm.isWritingMessage && _vm.isMobile() ? "expanded" : "collapsed",
          on: { click: _vm.closeCard }
        },
        [
          _vm.isWritingMessage && _vm.isMobile() && !_vm.isBrandableCard
            ? _c(
                "div",
                {
                  staticClass: "write-message-container",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "separator-container",
                      on: { touchstart: _vm.dragStart, touchend: _vm.dragEnd }
                    },
                    [_c("p", [_vm._v("Time to write your card message!")])]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "body-base text-center m-b-1rem" }, [
                    _vm._v(
                      "One of our team members will hand write your message and pack it in with your box."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-image-container" }, [
                    _c("p", { staticClass: "card-title text-center" }, [
                      _vm._v(_vm._s(_vm.selectedCard.title))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "w-100 flex flex-align-center gap-05vw" },
                      [
                        _c("img", {
                          staticClass: "flex-1",
                          attrs: {
                            loading: "lazy",
                            src: _vm._f("getProductImage")(_vm.selectedCard)
                          }
                        }),
                        _vm._v(" "),
                        _vm.selectedCard.images.length > 1
                          ? _c("img", {
                              staticClass: "h-auto flex-1",
                              attrs: {
                                width: "20",
                                height: "20",
                                src: _vm.selectedCard.images[1].src
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "write-container",
                      class: _vm.isBlankMessage ? "blank" : ""
                    },
                    [
                      _c("div", [
                        _vm.selectedCard.id != 7148612419749
                          ? _c(
                              "div",
                              { staticClass: "blank-card-container gap-05vw" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.isBlankMessage,
                                      expression: "isBlankMessage"
                                    }
                                  ],
                                  attrs: { id: "blankCard", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.isBlankMessage)
                                      ? _vm._i(_vm.isBlankMessage, null) > -1
                                      : _vm.isBlankMessage
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.isBlankMessage,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.isBlankMessage = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.isBlankMessage = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.isBlankMessage = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "color-link font-bold",
                                    attrs: { for: "blankCard" }
                                  },
                                  [_vm._v("Leave the card blank")]
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      !_vm.isBlankMessage
                        ? _c("div", { staticClass: "form-container" }, [
                            _c("div", { staticClass: "message-container" }, [
                              _c(
                                "label",
                                {
                                  class: _vm.showCardAlert ? "red" : "",
                                  attrs: { for: "message" }
                                },
                                [_vm._v("Your Message:")]
                              ),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.message,
                                    expression: "message"
                                  }
                                ],
                                attrs: {
                                  placeholder: "Start typing here...",
                                  maxlength: "200",
                                  cols: "30",
                                  rows: "3",
                                  id: "message"
                                },
                                domProps: { value: _vm.message },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.message = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "from-container" }, [
                              _c(
                                "label",
                                {
                                  class: _vm.showCardAlert ? "red" : "",
                                  attrs: { for: "from" }
                                },
                                [_vm._v("From:")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.from,
                                    expression: "from"
                                  }
                                ],
                                attrs: {
                                  placeholder: "Your Name",
                                  maxlength: "200",
                                  id: "from",
                                  type: "text"
                                },
                                domProps: { value: _vm.from },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.from = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "purple-span",
                                  class:
                                    _vm.remainingCharacters == 0 ? "red" : ""
                                },
                                [
                                  _vm._v(
                                    "Character Remaining " +
                                      _vm._s(_vm.remainingCharacters)
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "complete-box" }, [
                    _c(
                      "button",
                      {
                        staticClass: "happybox-button green border",
                        class: _vm.isLoading ? "isLoading" : "",
                        on: {
                          click: function($event) {
                            return _vm.bundle()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.buttonMobileText))]
                    )
                  ])
                ]
              )
            : _vm.isWritingMessage && _vm.isMobile() && _vm.isBrandableCard
            ? _c("BrandableCard", {
                attrs: {
                  selectedAddon: _vm.selectedCard,
                  isBlankMessage: _vm.isBlankMessage
                },
                on: {
                  closecard: _vm.closeCard,
                  changeblankmessage: _vm.changeBlankMessage,
                  changemessage: function($event) {
                    return _vm.changeMessage($event)
                  },
                  changefrom: function($event) {
                    return _vm.changeFrom($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.oosIsActive
        ? _c("OOSPopUp", {
            attrs: {
              oosProducts: _vm.noStockItems,
              firstStateProducts: _vm.currentStateSelectedAddons,
              fromSavedCart: true,
              fromCurated: false
            },
            on: {
              goback: function($event) {
                return _vm.goToAddonSelection()
              },
              continuesaved: function($event) {
                return _vm.bundle()
              },
              continuecurated: function($event) {
                return _vm.bundle()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading && _vm.cardSkipped
        ? _c("div", { staticClass: "global-spinner-container" }, [
            _c("div", { staticClass: "global-spinner" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.filterIsShown
        ? _c("CardFilter", {
            attrs: { occasionFilters: _vm.occasionFilters },
            on: {
              closefilter: function($event) {
                return _vm.showFilters()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "edit-btn" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/edit_icon_f176cdac-9643-4c58-a500-4a8c1cb57c27.svg?v=1725042634",
          alt: "edit"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }